var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"chart-legend",style:({ paddingLeft: _vm.left + 'px'})},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"chart-legend__item"},[_c('span',{staticClass:"chart-legend__bubble",style:({ background: item.color })}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.values[0].name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }